import styled from 'styled-components';

export const ModalWrapper = styled.div`
  position: absolute;
  width: 564px;
  height: 276px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 26px; 
  padding: 16px 32px 24px;
  opacity: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0px;

  @media (max-width: 768px) {
    width: 90%;
    height: auto;
    padding: 16px;
  }

  @media (max-width: 480px) {
    width: 95%;
    height: auto;
    padding: 12px;
    border-radius: 16px;
  }
`;

export const ModalDescription = styled.p`
  font-family: Mangueira;
  font-size: 26.05px;
  line-height: 40.17px;
  text-align: center;
  font-weight: 600;

  @media (max-width: 480px) {
    font-size: 20px;
    line-height: 30px;
    padding: 0 16px;
  }
`;

export const Highlight = styled.span`
  color: #000FFF;
  font-family: Mangueira;
  font-size: 26.05px;
  line-height: 40.17px;
  text-align: center;
  font-weight: 600;

  @media (max-width: 480px) {
    font-size: 20px;
    line-height: 30px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
  color: #000FFF;

  & > svg {
    color: #000FFF;
    font-size: 32px; /* Aumentando o tamanho */
    font-weight: bold; /* Negrito */
  }

  &:hover > svg {
    color: #000CCC;
  }

  @media (max-width: 768px) {
    top: 6px;
    right: 6px;

    & > svg {
      font-size: 28px;
    }
  }

  @media (max-width: 480px) {
    top: 6px;
    right: 6px;

    & > svg {
      font-size: 24px;
    }
  }
`;
